import { Model } from './model';
export class SuiteModel implements Model {
    id: string;
    name: string;
    suiteId: number;
    type: string = "suite";
      

}
